import Vue from 'vue';
import EasySlider from 'vue-easy-slider';
Vue.use(EasySlider);
